import QSelect from './src/QSelect.vue';

QSelect.install = function(Vue) {
  Vue.component(QSelect.name, QSelect);
};

export default QSelect;
